module.exports = __webpack_public_path__ + "media/entities/2313-ef880d5a.png";